(function() {
  'use strict';

  angular.module('app').factory('OrderService', OrderService);

  OrderService.$inject = ['$rootScope', 'API'];

  function OrderService($rootScope, API) {
    var service = {};

    /**
     * Get list of all or filtered Orders
     */
    service.All = function(params, callback) {
      API.get('/orders?{0}'.format(paramsToUrlQueryEncodeURIComponent(params)), callback, true);
    };

    service.GetOrderInfo = function(id, callback) {
      API.get('/orders/' + id, function(success, response) {
        if (success) {
        }
        callback(success, response);
      });
    };

    service.SetOrderStatus = function(id, post_data, callback) {
      API.patch('/orders/' + id, post_data, function(success, data) {
        if (success) {
          // NotifyService.Success(data.message, false);
        }
        callback(success, data);
      });
    };

    return service;
  }

})();
